import { finalSaleCalculate } from '../../utils/finalSale';

const finalSale = () => {
  const cartItems = document.querySelectorAll('.CartProduct');
  // Guard condition which will avoid calling final sale calculation if you are in PDP or Quick Shop
  if (!cartItems.length) return;

  finalSaleCalculate({
    cartFlag: true,
    productNodes: cartItems,
    isInternational: window.theme.country_iso !== 'US',
  })
    .then((results) => {
      cartItems.forEach((cartItem) => {
        // Don't set final node if finalSale was false
        if (!results.find((item) => item.id === cartItem.dataset.variantId && item.finalSale)) return;

        // Set final sale node
        const finalSaleNode = document.createElement('div');
        finalSaleNode.classList.add('CartProduct__final-sale');
        finalSaleNode.ariaLabel = 'Final Sale Item';
        finalSaleNode.innerHTML = 'Final Sale';
        cartItem.appendChild(finalSaleNode);
      });
    })
    .catch((err) => {
      console.error(`Error while trying calculate final sale on cart page: ${err}`);
    });
};

export default finalSale;
